<template>
  <vue-flashcard
    front="TRACKERSTACKER INVENTORY SYSTEM (SWIFT)"
    back="iPhone application that can be used by any type of business or even for personal use.
          User will be able to add and remove categories and data for the items."
    headerFront=''
    headerBack=''
    footerFront=''
    footerBack=''>     
  </vue-flashcard>
</template>

<script>
import vueFlashcard from 'vue-flashcard';

export default {
  components : {
    vueFlashcard
  }
}
</script>


// WEBPACK FOOTER //
// src/components/TrackerStacker.vue